<template lang="html">
    <span class="btn-add">
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
            <path fill="#fff" d="M22 10H12V0h-2v10H0v2h10v10h2V12h10z"/>
        </svg>
    </span>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>
